<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="7" sm="12" class="mt-2">
          <p style="font-size: 17px;color:#2284ab;">Add Nomination Details</p>
          <p></p>
          <div
            style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"
          >
            <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Nominee Name <span style='color:red'>*</span>"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                type="text"
                placeholder="Nominee Name"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.UserNominee.NomineeName"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Gender <span style='color:red'>*</span>"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-radio-group
                id="radiosn1"
                v-model="form.UserNominee.Gender"
                name="radioNomineeGender"
              >
                <b-form-radio value="1">Male</b-form-radio>
                <b-form-radio value="0">Female</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Birth Date <span style='color:red'>*</span>"
              label-size="sm"
              label-for="exampleInput3"
            >
              <!-- <b-form-input id="exampleInput2"
                            type="date"
                            v-model="form.UserNominee.DOB"
                            required size="sm"
              placeholder="Date of Birth"></b-form-input>-->
              <date-picker
                v-model="DOB"
                :not-after="currentDate"
                format="DD-MM-YYYY"
                lang="en"
                required
                size="small"
              ></date-picker>
              <p>Age: {{age}} yrs</p>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label-size="sm"
              label="Relationship <span style='color:red'>*</span>"
              label-for="exampleInput2"
            >
              <b-form-select
                id="exampleInput1"
                :options="relations"
                required
                size="sm"
                v-model="form.UserNominee.ReletionShip"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="igReln"
              horizontal
              label-size="sm"
              label="Relationship Details<span style='color:red'>*</span>"
              label-for="inpRD"
              v-if="form.UserNominee.ReletionShip ==8"
            >
              <b-form-input
                type="text"
                placeholder="Relationship Details"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.UserNominee.RelationDetail"
                id="inpRD"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-checkbox
              id="checkbox1"
              style="font-size:12px;padding-bottom:0px;padding-top:0px;height:auto;v-align:bottom"
              v-model="form.UserNominee.isMinor"
              size="sm"
            >Nominee is Minor</b-form-checkbox>
            <b-form-group
              id="igGrdName"
              horizontal
              v-if="form.UserNominee.isMinor"
              label="Guardian Name <span style='color:red'>*</span>"
              label-size="sm"
            >
              <b-form-input
                type="text"
                placeholder="Guardian Name"
                size="sm"
                required
                :formatter="format"
                lazy-formatter
                v-model="form.UserNominee.GuardianName"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="igGrdAdrs"
              horizontal
              v-if="form.UserNominee.isMinor"
              label="Guardian Address <span style='color:red'>*</span>"
              label-size="sm"
            >
              <b-form-input
                type="text"
                placeholder="Guardian Address"
                size="sm"
                required
                :formatter="format"
                lazy-formatter
                v-model="form.UserNominee.GuardianAddress"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="igGrdRln"
              horizontal
              v-if="form.UserNominee.isMinor"
              label="Guardian Relation with Minor <span style='color:red'>*</span>"
              label-size="sm"
            >
              <b-form-input
                type="text"
                placeholder="Guardian's Relation with Minor"
                size="sm"
                required
                :formatter="format"
                lazy-formatter
                v-model="form.UserNominee.GuardianRelation"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2 justify-content-md-center" v-if="!LockProfile">
        <b-col md="5" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col md="4" sm="12" style="text-align:right">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>
    <div
      style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"
      class="mt-2"
    >
      <p style="font-size: 17px;color:#2284ab;">Nomination Details</p>
      <b-row align-h="center">
        <b-col>
          <b-table
            show-empty
            head-variant="dark"
            stacked="md"
            bordered
            striped
            :items="nominees"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            style="font-size:12px"
          >
            <template slot="Gender" slot-scope="row">{{row.value?'Male':'Female'}}</template>
            <template slot="ReletionShip" slot-scope="row">
              {{row.value==1?'Father':row.value==2?'Mother':row.value==3?'Spouse':
              row.value==4?'Daughter':
              row.value==5?'Son':
              row.value==6?'Brother':
              row.value==7?'Sister':'Successor'}}
            </template>
            <template slot="show_details" slot-scope="row">
              <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
              <b-button
                size="sm"
                @click.stop="row.toggleDetails"
                variant="link"
                class="m-0"
              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
            </template>
            <template slot="actions" slot-scope="row">
              <b-button
                size="sm"
                @click.stop="editNominee(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="outline-success"
                v-b-tooltip.hover
                title="Edit Nominee"
                v-if="!LockProfile"
              >
                <i class="fa fa-edit" style="font-size:16px;color:blue"></i>
              </b-button>
              <b-button
                size="sm"
                @click.stop="deleteNominee(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="outline-danger"
                v-b-tooltip.hover
                title="Delete Nominee"
                v-if="!LockProfile"
              >
                <i class="fa fa-trash" style="font-size:16px;color:red"></i>
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <span>{{row.item.description}}</span>
              </b-card>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
//import DatePicker from 'vue2-datepicker';
import DatePicker from "vue2-datepicker";
var _currentDate = new Date();

const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];

export default {
  name: "NomineeDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      currentDate: _currentDate,
      relations: [
        { value: 1, text: "Father" },
        { value: 2, text: "Mother" },
        { value: 3, text: "Spouse" },
        { value: 5, text: "Son" },
        { value: 4, text: "Daughter" },
        { value: 6, text: "Brother" },
        { value: 7, text: "Sister" },
        { value: 8, text: "Successor" }
      ],

      // Md Tofiq (B) 28-2-19
      DOB: null,
      // Md(E)

      form: {
        UserNominee: {
          NomineeName: "",
          Gender: 1,
          DOB: null,
          ReletionShip: "",
          NomineeID: "00000000-0000-0000-0000-000000000000",
          UserID: "",
          GuardianName: "",
          GuardianAddress: "",
          GuardianRelation: ""
        },
        LoginID: ""
      },
      nominees: [],
      fields: [
        { key: "NomineeName", label: "Nominee Name", sortable: true },
        { key: "Gender", label: "Gender", sortable: true },
        {
          key: "DOB",
          label: "Birth Date",
          formatter: "convertDateFormat",
          sortable: true
        },
        { key: "ReletionShip", label: "Relation", sortable: true },
        { key: "RelationDetail", label:"Details"},
        { key: "GuardianName", label: "Guardian Name", sortable: true },
        { key: "GuardianAddress", label: "Guardian Address", sortable: true },
        { key: "GuardianRelation", label: "Guardian Relation", sortable: true },
        { key: "actions", label: "Edit" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedNomineeId: ""
    };
  },
  computed: {
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    },
    age() {
      let n = 0;
      //if (this.form.UserNominee.DOB) {
      if (this.DOB) {
        //let birthDate = new Date(this.form.UserNominee.DOB);
        let birthDate = new Date(this.convertDateFormatYMD(this.DOB));
        
        let incrementDate = new Date(birthDate);
        // console.log(incrementDate);
        let today = new Date();

        while (incrementDate < today) {
          n++;
          incrementDate.setYear(incrementDate.getFullYear() + 1);
        }
        n = n - 1;
        if (n < 18) {
          this.form.UserNominee.isMinor = true;
        } else {
          this.form.UserNominee.isMinor = false;
        }
      }
      return n;
    }
  },

  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    convertDateFormat(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      if (dbDateTime.getFullYear() == 1) {
        return null;
      }

      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate;
    },

    // Md Tofiq (B) 28-2-19
    convertDateFormatYMD(inDate) {
      let dbDateTime = new Date(inDate);
      let formattedDate =
        dbDateTime.getFullYear() +
        "-" +
        (dbDateTime.getMonth() + 1) +
        "-" +
        dbDateTime.getDate();
      return formattedDate;
    },
    // Md(E)

    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = true;
      this.$emit("clicked");
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.nominees.length >= 2 && this.form.UserNominee.NomineeID == "") {
        this.alertText = "You can add only two Nominees";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      }
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      this.form.UserNominee.UserID = userinfo.UserId;

      // Md Tofiq (B) 28-2-19
      this.form.UserNominee.DOB = this.convertDateFormatYMD(this.DOB);
      // Md(E)
      if (this.form.UserNominee.Gender == "1" || this.form.UserNominee.Gender == 1) {
         this.form.UserNominee.Gender = true;
       }
       else{
         this.form.UserNominee.Gender = false;
       }

      //let promise = apis.saveNomination(this.form);
      let promise = apis.saveNomination(this.form.UserNominee);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.getNominations();
            this.onReset();
            this.alertText = "Data Saved Successfully";
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form.UserNominee.NomineeID = "00000000-0000-0000-0000-000000000000";
      this.form.UserNominee.NomineeName = "";
      this.form.UserNominee.Gender = 1;
      this.form.UserNominee.DOB = null;
      this.form.UserNominee.ReletionShip = "";
      this.form.UserNominee.isMinor = false;
      this.form.UserNominee.GuardianName = "";
      this.form.UserNominee.GuardianAddress = "";
      this.form.UserNominee.GuardianRelation = "";
    },
    editNominee(item, index, target) {
      this.form.UserNominee.NomineeID = item.NomineeID;
      this.form.UserNominee.NomineeName = item.NomineeName;
      this.form.UserNominee.Gender = item.Gender ? 1 : 0;
      this.form.UserNominee.DOB = item.DOB.split("T")[0];
      this.form.UserNominee.ReletionShip = item.ReletionShip;
      this.form.UserNominee.isMinor = item.isLoading;
      this.form.UserNominee.GuardianName = item.GuardianName;
      this.form.UserNominee.GuardianAddress = item.GuardianAddress;
      this.form.UserNominee.GuardianRelation = item.GuardianRelation;
      this.form.UserNominee.RelationDetail = item.RelationDetail;

      // Md Tofiq (B) 28-2-19
      this.DOB = item.DOB;
      // Md(E)
    },
    deleteNominee(item, index, button) {
      this.form.UserNominee.NomineeID = item.NomineeID;
      this.form.UserNominee.NomineeName = item.NomineeName;
      this.form.UserNominee.Gender = item.Gender ? 1 : 0;
      this.form.UserNominee.DOB = item.DOB.split("T")[0];
      this.form.UserNominee.ReletionShip = item.ReletionShip;
      let info = "You want to delete record for:" + "\n" + item.NomineeName;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },

    modalCancel() {
      this.onReset();
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      this.form.UserNominee.UserID = userinfo.UserId;
      let promise = apis.deleteNominee(this.form.UserNominee);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            this.onReset();
            this.getNominations();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },
    getNominations() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadUserNominations(userinfo.UserId);

      promise
        .then(response => {
          //console.log('Nominee Reponse' ,response);
          if (response.status == 200) {
            this.nominees = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    this.getNominations();
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/Nomination.vue